<template>
  <div class="rm-screen rm-gm">
    <div v-if="loading && !rows.length" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>

    <template v-else>
      <div v-if="rows.length" class="rm-stats rm-stats--pair">
        <div class="rm-stat rm-stat--inverse">
          <span class="rm-stat__label">{{ $t("report_desktop.total_meals") }}</span>
          <span class="rm-stat__value rm-num">{{ total }}</span>
        </div>
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("meals") }}</span>
          <span class="rm-stat__value rm-num">{{ sortedRows.length }}</span>
        </div>
      </div>

      <article v-if="sortedRows.length" class="rm-card">
        <div v-for="row in sortedRows" :key="row.key" class="rm-gm-row">
          <div class="rm-gm-row__text">
            <span class="rm-gm-row__name">{{ row.name }}</span>
            <span v-if="showNotes && row.prilog" class="rm-muted">{{ row.prilog }}</span>
          </div>
          <b class="rm-gm-row__qty rm-num">{{ row.quantity }}</b>
          <div class="rm-progress rm-gm-row__bar" role="progressbar" :aria-valuenow="row.share" aria-valuemin="0" aria-valuemax="100">
            <div class="rm-progress__fill" :style="{ width: `${row.share}%` }"></div>
          </div>
        </div>
      </article>

      <div v-else class="rm-empty">{{ emptyTitle }}</div>
    </template>
  </div>
</template>

<script>
import "./guestMobileLists.scss";

/**
 * Obroci i Jela gostiju na telefonu: količina po jelu sa udelom u ukupnom. Ista svojstva kao
 * GuestMealsView (računar); podatke daje ekran (stari tab sa nizom { id, name, quantity, prilog }).
 */
export default {
  name: "GuestMobileMealsView",
  props: {
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    search: { type: String, default: "" },
    showNotes: { type: Boolean, default: false },
  },
  computed: {
    matched() {
      const rows = this.rows.map((row) => ({
        key: String(row.id ?? row.name),
        name: this.toLatin(row.name || ""),
        quantity: Number(row.quantity) || 0,
        prilog: this.toLatin(row.prilog || ""),
      }));
      return this.customSearch(rows, [{ value: "name" }, { value: "prilog" }], this.search);
    },
    total() {
      return this.matched.reduce((sum, row) => sum + row.quantity, 0);
    },
    sortedRows() {
      return [...this.matched]
        .sort((a, b) => b.quantity - a.quantity)
        .map((row) => ({ ...row, share: this.total ? Math.round((row.quantity / this.total) * 100) : 0 }));
    },
    emptyTitle() {
      return this.search ? this.$t("report_mobile.no_results_for", { search: this.search }) : this.$t("no_data_available");
    },
  },
};
</script>
